<template>
  <div>
    <Header :data-count="dataCount"/>
    <!-- <PaginationLeft/> -->
    <FavoriteList :favorites="favorites"/>
    <!-- <PaginationRight/> -->
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import FavoriteList from './components/FavoriteList'
import Footer from './components/Footer'
import PaginationLeft from './components/PaginationLeft'
import PaginationRight from './components/PaginationRight'
import {db} from './plugins/firebase'

export default {
  name: 'App',
  components: {
    Header,
    FavoriteList,
    Footer,
    PaginationLeft,
    PaginationRight
  },
  data: () => ({
    favorites: [],
    dataCount: 0
  }),
  firestore () {
    return {
      // firestoreのURULYコレクションを参照
      favorites: db.collection('URULY').orderBy('createDate', 'desc'),
      dataCount: db.collection('URULY').get().then(snap => {
        this.dataCount = snap.size
      })
    }
  }
}
</script>

<style>
body {
    background-color: #D77BBA;
    color: #fff;
    margin: 0;
}

h1, h2, h3 {
    color: #fff;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue